import { MuiShape } from '@lemontaps/lib/types/api';

export const defaultShape: MuiShape = {
  borderRadius: 10,
};
